import { TBoardUserMetaAction } from 'app/store/model/boardUserMeta/actions/types';

/**
 * default prefix "BOARD_USER_METAS"
 * */
export const AT_BOARD_USER_META_ACTION_SET = 'BOARD_USER_METAS__BOARD_USER_META_ACTION_SET';

export interface IBoardUserMetaActionSetAction {
    type: typeof AT_BOARD_USER_META_ACTION_SET,
    boardId: number,
    boardUserMetaAction: TBoardUserMetaAction
}
export type TBoardUserMetasAction = (IBoardUserMetaActionSetAction);
